module.exports = {
	"id": "MX",
	"name": "Mexico",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.022072,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.011036,
			"19": null,
			"20": null,
			"21": 0.011036,
			"22": 0.05518,
			"23": null,
			"24": null,
			"25": 0.005518,
			"26": 0.016554,
			"27": 0.011036,
			"28": null,
			"29": 0.011036,
			"30": 0.005518,
			"31": 0.016554,
			"32": 0.011036,
			"33": 0.011036,
			"34": 0.033108,
			"35": 0.038626,
			"36": 0.033108,
			"37": 0.022072,
			"38": 0.033108,
			"39": 0.044144,
			"40": 0.033108,
			"41": 0.022072,
			"42": 0.02759,
			"43": 0.104842,
			"44": 0.066216,
			"45": 0.049662,
			"46": 0.104842,
			"47": 0.088288,
			"48": 0.11036,
			"49": 1.997516,
			"50": 0.148986,
			"51": 0.52421,
			"52": 0.5518,
			"53": 25.791132,
			"54": 7.195472,
			"55": 0.044144,
			"56": 0.011036,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.005518,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": 0.005518,
			"32": null,
			"33": 0.005518,
			"34": 0.022072,
			"35": 0.011036,
			"36": 0.011036,
			"37": 0.011036,
			"38": 0.049662,
			"39": 0.022072,
			"40": 0.022072,
			"41": 0.022072,
			"42": 0.02759,
			"43": 0.08277,
			"44": 0.033108,
			"45": 0.066216,
			"46": 0.044144,
			"47": 0.2759,
			"48": 0.342116,
			"49": 3.64188,
			"50": 0.022072,
			"51": 0.005518,
			"52": null,
			"3.5": null,
			"3.6": 0.011036
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.011036,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.016554,
			"37": 0.066216,
			"38": 0.022072,
			"39": 0.011036,
			"40": 0.33108,
			"41": 0.049662,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.016554
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.033108,
			"6": 0.011036,
			"7": 0.033108,
			"8": 0.204166,
			"9": 0.242792,
			"10": 1.064974,
			"3.1": null,
			"3.2": null,
			"5.1": 0.066216,
			"6.1": 0.049662,
			"7.1": 0.011036,
			"9.1": 0.816664
		},
		"ios_saf": {
			"8": 0,
			"10": 5.04314938551,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.135907040383,
			"8.1-8.4": 0.251082498335,
			"9.0-9.2": 0.11978247627,
			"9.3": 1.8274505995
		},
		"android": {
			"3": 0,
			"4": 0.0757191627907,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00946489534884,
			"4.1": 0.273129837209,
			"4.2-4.3": 0.682824593023,
			"4.4": 1.56576411628,
			"4.4.3-4.4.4": 1.57928539535
		},
		"ie": {
			"6": 0.00554267064083,
			"7": 0.0110853412817,
			"8": 0.260505520119,
			"9": 0.376901603577,
			"10": 0.26604819076,
			"11": 2.79904867362,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0924180822055,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00256716895015
		},
		"edge": {
			"12": 0.099324,
			"13": 0.402814,
			"14": 0.91047
		},
		"ie_mob": {
			"10": 0.189127774648,
			"11": 0.770020225352
		},
		"bb": {
			"7": 0.026892,
			"10": null
		},
		"samsung": {
			"0": 1.29978
		},
		"and_uc": {
			"0": 0.304776
		},
		"op_mini": {
			"0": 1.24513274884
		},
		"and_chr": {
			"0": 33.266724
		},
		"and_ff": {
			"0": 0.026892
		}
	},
	"total": 98.979618
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/MX.json
 ** module id = 601
 ** module chunks = 0
 **/